const SCROLLED_POSITIONS_KEY = 'scrll_pos';
export class ScrollHandler {
    static #instance;
    constructor() { }
    static get instance() {
        if (!this.#instance)
            this.#instance = new ScrollHandler();
        return this.#instance;
    }
    saveScrollPosition(href, scrolled) {
        const scrolledPositions = this.getScrollPositions();
        scrolledPositions[href] = scrolled;
        sessionStorage.setItem(SCROLLED_POSITIONS_KEY, JSON.stringify(scrolledPositions));
    }
    getScrollPosition(href) {
        const scrolledPositions = JSON.parse(sessionStorage.getItem(SCROLLED_POSITIONS_KEY) ?? '{}');
        return scrolledPositions[href] ?? 0;
    }
    getScrollPositions() {
        return JSON.parse(sessionStorage.getItem(SCROLLED_POSITIONS_KEY) ?? '{}');
    }
}
//# sourceMappingURL=scroll.handler.js.map